import { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  html {
    & > body {
      background-color: #2e2e2e;

      & > #root {
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
        font-weight: 400;
      }
    }
  }
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const Header = styled.h1`
  color: #fff;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
  font-weight: 400;
`;

const Content = styled.div`
  background-color: #ffffff;
  border-radius: 20px;
  max-width: 530px;
  padding: 20px;
  width: 100%;
`;

const Layout: FC = ({ children }) => (
  <>
    <GlobalStyle />
    <Wrapper>
      <Header>BitClout Blacklist</Header>
      <Content>{children}</Content>
    </Wrapper>
  </>
);

export default Layout;
